import React, { Fragment, useState } from "react";
import { NavLink } from "react-router-dom";
import { PrimaryButtonWithIcon } from "./Buttons";

const Navbar = () => {
  const [toggleNav, setToggleNav] = useState(false);

  const handleToggleNav = () => {
    setToggleNav(!toggleNav);
  };

  return (
    <Fragment>
      <div className="flex justify-between">
        <div className="self-center">
          <NavLink to={"/"}>
            <h3 className="font-bold text-dark-blue">🟠 The 360 Believer</h3>
          </NavLink>
        </div>
        <div
          className="self-center block lg:hidden cursor-pointer"
          onClick={handleToggleNav}
        >
          <svg
            xmlns="http://www.w3.org/2000/svg"
            fill="currentColor"
            className="bi bi-list w-8 h-8"
            viewBox="0 0 16 16"
          >
            <path
              fillRule="evenodd"
              d="M2.5 12a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5zm0-4a.5.5 0 0 1 .5-.5h10a.5.5 0 0 1 0 1H3a.5.5 0 0 1-.5-.5z"
            />
          </svg>
        </div>

        <div className="lg:flex gap-10 font-cRegular hidden">
          {/* <div className="self-center">
            <NavLink to="/about-the-host">About The Host</NavLink>
          </div> */}
          <div className="self-center">
            <NavLink to="/">Home</NavLink>
          </div>
          <div className="self-center">
            <NavLink to="/podcasts">Podcasts</NavLink>
          </div>
          {/* <div className="self-center">
            <NavLink to="/blog">Blog</NavLink>
          </div> */}
          <div className="self-center">
            <NavLink to="/store">Store</NavLink>
          </div>
          {/* <div className="self-center">
            <NavLink to="/contact-us">Contact Us</NavLink>
          </div> */}
        </div>
        <div className="hidden lg:block">
          <PrimaryButtonWithIcon
            btnText={"Give"}
            url="/give"
            icon={
              <svg
                xmlns="http://www.w3.org/2000/svg"
                width="16"
                height="16"
                fill="currentColor"
                className="bi bi-wallet2"
                viewBox="0 0 16 16"
              >
                <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
              </svg>
            }
          />
        </div>
      </div>
      {/* Mobile Nav */}
      <div className="mt-4">
        <div
          className={`bg-white myShadow rounded lg:hidden ${
            toggleNav ? `block` : `hidden`
          }`}
        >
          <ul className="font-semibold">
            {/* <li className="p-4">
              <NavLink to="/about-the-host">About The Host</NavLink>
            </li> */}
            <hr />
            <li className="p-4">
              <NavLink to="/">Home</NavLink>
            </li>
            <hr />
            <li className="p-4">
              <NavLink to="/podcasts">Podcasts</NavLink>
            </li>
            <hr />
            {/* <li className="p-4">
              <NavLink to="/blog">Blog</NavLink>
            </li> */}
            <hr />
            <li className="p-4">
              <NavLink to="/store">Store</NavLink>
            </li>
            <hr />
            <div className="block lg:hidden p-4">
              <PrimaryButtonWithIcon
                btnText={"Give"}
                url="/give"
                icon={
                  <svg
                    xmlns="http://www.w3.org/2000/svg"
                    width="16"
                    height="16"
                    fill="currentColor"
                    className="bi bi-wallet2"
                    viewBox="0 0 16 16"
                  >
                    <path d="M12.136.326A1.5 1.5 0 0 1 14 1.78V3h.5A1.5 1.5 0 0 1 16 4.5v9a1.5 1.5 0 0 1-1.5 1.5h-13A1.5 1.5 0 0 1 0 13.5v-9a1.5 1.5 0 0 1 1.432-1.499L12.136.326zM5.562 3H13V1.78a.5.5 0 0 0-.621-.484L5.562 3zM1.5 4a.5.5 0 0 0-.5.5v9a.5.5 0 0 0 .5.5h13a.5.5 0 0 0 .5-.5v-9a.5.5 0 0 0-.5-.5h-13z" />
                  </svg>
                }
              />
            </div>
            <hr />
          </ul>
        </div>
      </div>
    </Fragment>
  );
};

export default Navbar;
